module.exports = __webpack_public_path__ + "img/OldSocialInteraction.1982202c.png";